import { bouncySumsDummyData } from '@/features/bouncySums';
import { laneChooserDummyData } from '@/features/laneChooser';
import { letterPartyDummyData } from '@/features/letterParty';
import { measurementGameDummyData } from '@/features/measurementGame';
import { timeGameDummyData } from '@/features/timeGame';
import { tracingGameDummyData } from '@/features/tracingGame';
import { GAME_TYPES } from './store/constants';

import type { SupportedGameType } from './queryParams';

export const getDummyGameData = (gameType: SupportedGameType | null) => {
	if (gameType === GAME_TYPES.BOUNCY_SUMS_GAME) {
		return bouncySumsDummyData;
	}

	if (gameType === GAME_TYPES.LANE_CHOOSER_GAME) {
		return laneChooserDummyData.user_learning_path_section;
	}

	if (gameType === GAME_TYPES.LETTER_PARTY_GAME) {
		return letterPartyDummyData.user_learning_path_section;
	}

	if (gameType === GAME_TYPES.TRACING_GAME) {
		return tracingGameDummyData;
	}

	if (gameType === GAME_TYPES.MEASUREMENT_GAME) {
		return measurementGameDummyData.user_learning_path_section;
	}

	return timeGameDummyData.user_learning_path_section;
};
